import React from "react";

export default function Quote(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="134" height="90">
			<text
				data-name="“"
				fill={props.color || "#db6048"}
				fontSize="200"
				fontFamily="Arial-BoldMT, Arial"
				fontWeight="700"
			>
				<tspan x="17" y="160">
					“
				</tspan>
			</text>
		</svg>
		// <svg xmlns="http://www.w3.org/2000/svg" width="134" height="90">
		// 	<text data-name="“" fill="#db6048" font-size="200" font-family="SegoeUI-Bold, Segoe UI" font-weight="700">
		// 		<tspan x="17.684" y="190">
		// 			“
		// 		</tspan>
		// 	</text>
		// </svg>
	);
}
